// extracted by mini-css-extract-plugin
module.exports = {"container-header":"SubscriptionFormHeader_container-header__4T82h","images-icon":"SubscriptionFormHeader_images-icon__Td_mh"};